<template>
  <div>
     <div class="check_line">
      <div class="check_line_btns" :class=" more ?'btns_box':''">
        <div id="btns_box">
          <div class="check_el_btn" >
            <el-button style="margin-left: 4px;" 
              :type="ckIndex == -1?'primary':''" @click="ckIndex = -1">
                我的机构权限<span :class=" ckIndex == -1 ? 'btn_color':'btn_colors'">(组织机构)</span>
              </el-button>
          </div>
          <div class="check_el_btn" v-for="(item,index) in listData.groupList" :key="index" >
            <el-button @click="roleBtn(item,index)" :type=" ckIndex == index ? 'primary' : '' ">
                {{item.groupName}}<span :class=" ckIndex == index ? 'btn_color':'btn_colors'">(管理范围)</span>
            </el-button>
          </div>
        </div>
      </div>
      <div class="check_line_more" v-if="showMoreBtn">
        <el-button v-if="more"  @click="clickMore('open')">更多</el-button>
        <el-button v-else  @click="clickMore('close')">收起</el-button>
      </div>
    </div>
    <permission v-if="ckIndex == -1" :isShow="isShow" :organizationList="listData.organizationList" ></permission>
    <info_list v-else-if="ckIndex != -1 && aaDataList != {}" :isShow="isShow" :groupId="groupId" :aaDataList="aaDataList"></info_list>
  </div>
</template>
<script>
  import info_list from './common/info_list.vue'
  import permission from './common/permission.vue'
  export default {
    components:{
      info_list,
      permission
    },
    props:{
      listData:{
        type: Object
      },
    },
    data () {
      return {
        ckIndex: -1,
        showMoreBtn: false,
        more: true,
        aaDataList:{},
        groupId:"",
        isShow: false,
      }
    },
    methods:{
      roleBtn(item,index){
        let vm = this
        vm.ckIndex = index
        vm.groupId = item.id
        vm.isShow = true
        http.get(InterfacePrefix['platform']+'/user/authority/'+vm.$store.state.userInfo.id+'/group/'+item.id).then(xhr=>{
          vm.aaDataList = xhr.data.data
        })
      },
      
      moreBtn() {
        let vm = this;
        let seHeight = $('#btns_box')[0].offsetHeight
        if (seHeight > 36) {
          vm.showMoreBtn = true;
        } else {
          vm.showMoreBtn = false;
        }
      },
    }
  }
</script>
<style lang="less" scoped>
  .check_line{ position: relative;
    .check_line_btns{ padding-right: 65px;
      .check_el_btn{ display: inline-block; margin: 0 8px 4px 0; }
    }
    .btns_box{ height: 36px; overflow: hidden; }
    .check_line_more{ position: absolute; text-align: right; right: 0; top: 0; width: 80px; z-index: 101; }
  }
  .btn_colors{ color: #027060}
  .btn_color{ color: #93fdf5 }
</style>







// WEBPACK FOOTER //
// src/components/setting/basic_information/permission/scope.vue